import React, { useEffect, useRef } from 'react'
import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { Swiper, SwiperSlide } from 'swiper/react'

// Styles
import styles from './style.module.scss'
// Lib

import handleImageBlur from '@/methods/handleImageBlur'
import { PlaceholderType } from '@/components/common/Image'

interface Props {
  images: string[]
  skuImage: string
  activeIndex: number
  onSlide: (index: number) => void
}

const MainImageSwiper = ({ images, skuImage, activeIndex, onSlide }: Props) => {
  const cx = classnames.bind(styles)
  const swiperRef: any = useRef(null)
  useEffect(() => {
    swiperRef.current.slideTo(activeIndex)
  }, [activeIndex])

  return (
    <Swiper
      initialSlide={activeIndex}
      onActiveIndexChange={(swiper) => {
        onSlide(swiper.realIndex)
      }}
      onInit={(ref) => (swiperRef.current = ref)}
      className={cx('swiper')}
      slidesPerView={'auto'}
      slideToClickedSlide
      grabCursor
    >
      {images.map((imageUrl, index) => (
        <SwiperSlide key={index}>
          <Image
            alt='product-image'
            placeholder={PlaceholderType.blur}
            blurDataURL={handleImageBlur()}
            src={skuImage ? skuImage : imageUrl}
            fill
            style={{ objectFit: 'contain' }}
            sizes='(max-width: 710px) 1200px, (max-width: 1200px) 50vw, 1200px'
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
export default MainImageSwiper
